// services/authService.js
import api from "./api.js";
// import { getUser } from "./userService.js";

// تسجيل الدخول
// export const login = async (email, password) => {
//   try {
//     await api.post("/Auth/login", { email, password });
//     const data = await getUser();
//     console.log("Data:--> ",data);
    
//     return data;
//   } catch (error) {
//     const errMsg =
//       error.response?.data?.message ||
//       error.message ||
//       "Login failed. Please try again.";
//     console.error("Login Failed:", errMsg);
//     throw new Error(errMsg); // علشان يظهر في واجهة المستخدم
//   }
// };

export const signup = async (userData) => {
  try {
    const response = await api.post("/Auth/signUp", {
      fullName: userData.fullName,
      email: userData.email,
      password: userData.password,
      universtyID: userData.universtyID,
      gender: userData.gender,
      phone: userData.phone,
      faculty: userData.faculty,
      level: userData.level,
    });
    return response.data;
  } catch (error) {
    const errMsg =
      error ||
      "Sign up failed. Please try again.";
    console.error("Sign Up Failed:", errMsg);
    throw errMsg;
    // throw new Error(errMsg); // علشان يظهر في واجهة المستخدم
  }
};

export const confirmEmailOTP = async (email, otp) => {
  try {
    const response = await api.patch("/Auth/confirmOTP", { email, otp });
    return response.data;
  } catch (error) {
    const errMsg =
      error?.response?.data?.message ||
      error?.message ||
      "OTP verification failed. Please try again.";

    console.error("OTP Verification Failed:", errMsg);
    throw new Error(errMsg);
  }
};
export const resendEmailOTP = async (email) => {
  try {
    const response = await api.patch("/Auth/resendOTP", { email });
    return response.data;
  } catch (error) {
    const errMsg =
      error?.response?.data?.message ||
      error?.message ||
      "resend OTP failed. Please try again.";
    console.error("OTP resend Failed:", errMsg);
    throw new Error(errMsg);
  }
};

export const Ex_signup = async (data) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      let users = JSON.parse(localStorage.getItem("users")) || [];

      // التأكد إن الإيميل مش مستخدم قبل كده
      const existingUser = users.find((u) => u.email === data.email);
      if (existingUser) {
        reject(new Error("Email already registered"));
        return;
      }

      // إضافة المستخدم الجديد
      const newUser = {
        ...data,
        id: Date.now(),
        role: "external_organizer",
      };
      users.push(newUser);
      localStorage.setItem("users", JSON.stringify(users));

      resolve({
        message: "Signup successful",
        user: newUser,
      });
    }, 1500); // ⏳ تأخير لمحاكاة الاتصال بالسيرفر
  });
};

// export const userInfo = () => {
//   return JSON.parse(localStorage.getItem("currentUser")) || "";
// };

// export const getCurrentUser = async () => {
//   const res = await api.get("http://localhost:5000/api/auth/me");
//   return res.data;
// };
